import React from 'react';
import PropTypes from 'prop-types';

import { Colors, FontSizes, FontWeights } from '../Theme';

const Breadcrumbs = ({ crumbs, current }) => {
  const styles = {
    component: {
      display: 'flex',
      alignItems: 'center',
      margin: '30px 0'
    },
    breadcrumb: {
      fontSize: FontSizes.REGULAR,
      fontWeight: FontWeights.MEDIUM,
      textDecoration: 'none',
      color: Colors.PRIMARY.hex,
      cursor: 'pointer'
    },
    icon: {
      margin: '0 10px',
      color: '#ccc',
      fontSize: 18
    },
    current: {
      fontSize: FontSizes.REGULAR,
      fontWeight: FontWeights.MEDIUM,
      color: '#999'
    }
  };

  return (
    <div style={styles.component}>
      {crumbs.map((c, i) => {
        return (
          <React.Fragment key={i}>
            <div onClick={c.onClick} style={styles.breadcrumb}>
              {c.label}
            </div>
            <i className='mdi mdi-chevron-right' style={styles.icon} />
          </React.Fragment>
        );
      })}

      {current ? <span style={styles.current}>{current}</span> : null}
    </div>
  );
};

Breadcrumbs.propTypes = {
  crumbs: PropTypes.array,
  current: PropTypes.string
};

export default Breadcrumbs;
